import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import "./details.css";
import photo from "../assets/photo.png";
import { getContactImageUrl } from "../../config";
import { getContactImageUrl2 } from "../../config";

import Steeper from "./steeper";
class LeadDetails extends Component {
  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  render() {
    let details = this.props.details;
    // let customer = this.props.Customer;
    let campaigns = this.props.Campaigns;
    let image = details.profileimage ? details.profileimage.substr(0, 5) : "";

    return (
      <div className="Details">
        <div className="Data">
          <div className="Close">
            <h3 style={{ color: "#346beb" }}>{details.name}</h3>
            <div>
              <CloseIcon
                onClick={this.props.Close}
                style={{ cursor: "pointer" }}
                fontSize="small"
              />
            </div>
          </div>
          <div className="Headline">
            <div className="Phone">
              <div className="Image">
                {image === "https" ? (
                  // <img src={details.profileimage} alt="profile" />
                  <img
                    alt="Profile"
                    src={details.profileimage}
                    onError={({ currentTarget }) => {
                      let imageSourceUrl = getContactImageUrl;
                      if (details.id > 917500) {
                        imageSourceUrl = getContactImageUrl2;
                      }
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = imageSourceUrl.url + details.image;
                    }}
                  />
                ) : (
                  <img src={photo} alt="profile" />
                )}
                {/* {image !== "https" ? (
                  <img src={details.profileimage} />
                ) : (
                  <img src={photo} />
                )} */}
                {/* {details.profileimage ? (
                  <img src={details.profileimage} />
                ) : (
                  <img src={photo} />
                )} */}
              </div>
              <div>
                <ul>
                  {details.headline ? (
                    <li>
                      <span>Headline</span>
                      <span>:</span>
                      <span>{details.headline}</span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.phonenumber ? (
                    <li>
                      <span>Phone</span>
                      <span>:</span>
                      <span>{details.phonenumber}</span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.email ? (
                    <li>
                      <span>Email</span>
                      <span>:</span>
                      <span>{details.email}</span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.dateofbirth ? (
                    <li>
                      <span>D.O.B</span>
                      <span>:</span>
                      <span>{details.dateofbirth}</span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
          </div>
          <Steeper Status={this.props.Status} />
          {details.location ? (
            <div className="Address">
              <div className="State">
                <ul>
                  <li>
                    <span>Location</span>
                    <span>:</span>
                    <span>{details.location}</span>
                  </li>
                  <li>
                    <span>State</span>
                    <span>:</span>
                    <span>{details.state}</span>
                  </li>
                  <li>
                    <span>Country</span>
                    <span>:</span>
                    <span>{details.country}</span>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            " "
          )}
          {details.designation || details.organization ? (
            <div className="Current">
              <div className="Company">
                <ul>
                  {details.designation ? (
                    <li>
                      <span>Current Position</span>
                      <span>:</span>
                      <span>{details.designation}</span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.organization ? (
                    <li>
                      <span>Current Company</span>
                      <span>:</span>
                      <span>{details.organization}</span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.industry ? (
                    <li>
                      <span>Industry</span>
                      <span>:</span>
                      <span>{details.industry}</span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
          ) : (
            ""
          )}
          {details.twitter ||
          details.skype ||
          details.numberoffollowers ||
          details.linkedinid ? (
            <div className="Twitter">
              <div className="Skype">
                <ul>
                  {details.twitter ? (
                    <li>
                      <span>Twitter</span>
                      <span>:</span>
                      <span>
                        {details.twitter}
                        {/* <a
                          href={details.twitter}
                          title={details.twitter}
                          target="_blank"
                        ></a> */}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.skype ? (
                    <li>
                      <span>Skype</span>
                      <span>:</span>
                      <span>{details.skype}</span>
                    </li>
                  ) : (
                    ""
                  )}
                  {details.numberoffollowers ? (
                    <li>
                      <span>Followers</span>
                      <span>:</span>
                      <span>
                        {details.numberoffollowers}
                        {/* <a
                          href={details.twitter}
                          title={details.twitter}
                          target="_blank"
                        ></a> */}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}

                  {details.linkedinid ? (
                    <li>
                      <span>LinkedIn</span>
                      <span>:</span>
                      <span>
                        <a
                          href={details.linkedinid}
                          title={details.linkedinid}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {details.linkedinid}
                        </a>
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
          ) : (
            ""
          )}
          {details.campaignstatus !== undefined ? (
            <div className="Engaged">
              <div className="Active">
                {campaigns.map((item, key) => {
                  return (
                    <div key={key} className="campaignTableInfo">
                      <div>
                        <span>{item.name}</span>
                        <span>{details.campaignstatus}</span>
                        <span>{details.contactstatus}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default LeadDetails;
